import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'dateToTime'
})
export class DateToTimePipe implements PipeTransform {
  transform(value: Date): number {
    if (value instanceof Date) return value.getTime();
    return null;
  }
}
